

import { useEffect, useRef, useState } from 'react';

const STATS = [
  { value: 60, suffix: '+', label: 'Wdrożeń AI dla firm', color: '#00d4ff' },
  { value: 80, suffix: '%', label: 'Redukcja czasu obsługi klienta', color: '#00ff88' },
  { value: 24, suffix: '/7', label: 'Agenci AI pracują bez przerwy', color: '#ff6b9d' },
  { value: 5, suffix: 'lat', label: 'Doświadczenia w AI & Digital', color: '#00d4ff' },
];

function useCountUp(target: number, active: boolean, duration = 2000) {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!active) return;
    let start = 0;
    const steps = 60;
    const step = target / steps;
    const interval = duration / steps;
    const timer = setInterval(() => {
      start += step;
      if (start >= target) { setCount(target); clearInterval(timer); }
      else setCount(Math.floor(start));
    }, interval);
    return () => clearInterval(timer);
  }, [active, target, duration]);
  return count;
}

function StatCard({ value, suffix, label, color, active }: { value: number; suffix: string; label: string; color: string; active: boolean }) {
  const count = useCountUp(value, active);
  return (
    <div
      className="relative group flex flex-col items-center justify-center p-10 rounded-2xl border border-white/10 bg-white/[0.03] backdrop-blur-sm hover:border-white/20 transition-all duration-500 overflow-hidden cursor-default"
    >
      <div
        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{ background: `radial-gradient(circle at 50% 50%, ${color}10 0%, transparent 70%)` }}
      />
      <div
        className="text-6xl md:text-7xl font-black mb-3 tabular-nums"
        style={{ color }}
      >
        {count}{suffix}
      </div>
      <p className="text-white/50 text-sm text-center font-medium">{label}</p>
      <div
        className="absolute bottom-0 left-0 right-0 h-0.5 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
        style={{ background: `linear-gradient(90deg, transparent, ${color}, transparent)` }}
      />
    </div>
  );
}

export default function StatsSection() {
  const ref = useRef<HTMLDivElement>(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setActive(true); },
      { threshold: 0.3 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="relative py-24 bg-[#080808] overflow-hidden">
      <div className="absolute inset-0 opacity-5 pointer-events-none"
        style={{
          backgroundImage: 'radial-gradient(circle at 20% 50%, #00d4ff 0%, transparent 50%), radial-gradient(circle at 80% 50%, #00ff88 0%, transparent 50%)',
        }}
      />
      <div className="max-w-[1400px] mx-auto px-6">
        <div className="text-center mb-14">
          <p className="text-[#00d4ff] text-xs uppercase tracking-[3px] font-semibold mb-3">Liczby mówią same za siebie</p>
          <h2 className="text-3xl md:text-4xl font-bold text-white">AI, które realnie zmienia wyniki biznesowe</h2>
        </div>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
          {STATS.map((s) => (
            <StatCard key={s.label} {...s} active={active} />
          ))}
        </div>
      </div>
    </section>
  );
}

